/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Prefer_Property_AgentInputs */

const cs_automation_prefer_property_agent = /** @type {(inputs: Automation_Prefer_Property_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferovat agenta nemovitosti`)
};

const en_automation_prefer_property_agent = /** @type {(inputs: Automation_Prefer_Property_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer property agent`)
};

/**
* | output |
* | --- |
* | "Prefer property agent" |
*
* @param {Automation_Prefer_Property_AgentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_prefer_property_agent = /** @type {((inputs?: Automation_Prefer_Property_AgentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Prefer_Property_AgentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_prefer_property_agent(inputs)
	return cs_automation_prefer_property_agent(inputs)
});